
export const searchItems = [
  {
    label: '鱼住门店名称',
    type: 'input',
    decorator: ['name'],
    placeholder: '请输入'
  },
  {
    label: '支付宝门店名称',
    type: 'input',
    decorator: ['zfbStoreName'],
    placeholder: '请输入'
  },
  {
    label: '门店编码',
    type: 'input',
    decorator: ['sn'],
    placeholder: '请输入'
  },
  {
    label: '门店地址',
    type: 'input',
    decorator: ['address'],
    placeholder: '请输入'
  },
  {
    label: '运营者',
    type: 'input',
    decorator: ['operatorName'],
    placeholder: '请输入'
  },
  {
    label: '运营者手机',
    type: 'input',
    decorator: ['operatorPhone'],
    placeholder: '请输入'
  }
]
